import { render, staticRenderFns } from "./MaydayWebProductNotificationsCard.vue?vue&type=template&id=130ba934&scoped=true&"
import script from "./MaydayWebProductNotificationsCard.vue?vue&type=script&lang=js&"
export * from "./MaydayWebProductNotificationsCard.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebProductNotificationsCard.vue?vue&type=style&index=0&id=130ba934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ba934",
  null
  
)

export default component.exports